export default __webpack_public_path__ + "static/B0245-a0c01c8415d0a2731a46e8a58796ca5f.png";